/* src/app/shared/components/open-invoices/open-invoices.component.scss */
.open-invoices {
  width: 100%;
}
.open-invoices__header {
  margin-bottom: 10px;
}
.open-invoices__table {
  width: 100%;
}
.open-invoices__th,
.open-invoices__td {
  padding: 12px 16px;
}
.open-invoices__total-label {
  text-align: right !important;
  font-weight: 600;
  opacity: 0.9;
}
.open-invoices__total-value {
  font-weight: 700;
}
.open-invoices__not-found {
  margin-left: 12px;
}
.mat-column-invoiceAmount,
.mat-column-paymentAmount,
.mat-column-totalDue {
  text-align: right;
}
.open-invoices__td--id,
.open-invoices__td--amount,
.open-invoices__th--amount {
  width: 20%;
}
.open-invoices__th--date {
  width: 10%;
}
.open-invoices__td--selection {
  width: 50px;
}
.open-invoices__stripe-form {
  margin: 5% 10%;
}
.open-invoices__stripe-form__submit {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.open-invoices__stripe-form__submit__button {
  width: 300px;
}
.open-invoices__stripe-form__processing-message {
  background-color: #e8f4ff;
  border: 1px solid #b3d1ff;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}
.open-invoices__stripe-form__processing-message p {
  color: #007bff;
  margin: 0;
}
.open-invoices__stripe-form__error-message {
  background-color: #ffe8e8;
  border: 1px solid #ffb3b3;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}
.open-invoices__stripe-form__error-message p {
  color: #ff0000;
  margin: 0;
}
.open-invoices__view {
  text-decoration: underline;
  cursor: pointer;
}
.spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
/*# sourceMappingURL=open-invoices.component.css.map */
